module.exports = __webpack_public_path__ + "static/tara3-b13363a6e0731eb3b87e4c3ac485277d.jpg";